'use strict';

const _ = require('underscore');
const Mn = require('backbone.marionette');
const i18n = require('i18next');
const RelatedKeys = require('common/domain/value/related-keys');
const AuthService = require('system/domain/service/auth');
const NavView = require('balus/ui/view/body/diagram/nav/index');
const SyncState = require('system/domain/entity/sync-state');
const ToolbarView = require('balus/ui/view/body/diagram/toolbar/index');
const CanvasView = require('balus/ui/view/body/diagram/content/index');
const TagAction = require('system/domain/action/tag');
const ModeIndicatorView = require('common/ui/view/mode-indicator');
const SidebarView = require('common/ui/view/sidebar/index');
const SidebarCollection = require('common/ui/view/sidebar/collection');
const ElementAction = require('system/domain/action/element');
const ElementRepository = require('system/domain/repository/element');
const DiagramRepository = require('system/domain/repository/diagram');
const TagListView = require('system/ui/view/tag/list');
const OwnerListView = require('system/ui/view/owner/list');
const Template = require('balus/ui/template/body/diagram-import/index.hbs');
const CoverView = require('balus/ui/view/body/diagram-import/cover');
const DescriptionView = require('balus/ui/view/body/diagram/sidebar/description');
const Dispatcher = require('common/domain/repository/dispatcher');
const Actions = require('common/domain/action/index');
const DiagramImportAPI = require('balus/infra/api/diagram/import');
const DiagramModel = require('system/domain/entity/diagram');

module.exports = Mn.View.extend({
    className: 'row',
    template: Template,
    regions: {
        nav: '#nav',
        cover: '#cover',
        toolbar: '#toolbar',
        content: '#content',
        sidebar: '#sidebar',
        modeIndicator: '#mode-indicator'
    },

    onRender: function() {
        const context = this.getOption('context');
        const appInfo = context.getAppInfo();
        const user = context.getUser();
        const group = context.getGroup();
        const project = context.getProject();
        const channel = this.getOption('channel');
        const importRequestID = this.getOption('importRequestID');

        const urlParams = new URLSearchParams(location.search);
        const dt = urlParams.get('dt');
        const oldContext = {
            groupId: group.id,
            projectId: this.model.getProjectId(),
            diagramId: this.model.id,
            dt: dt
        };

        this.showChildView('cover', new CoverView({
            model: this.model,
            project: project
        }));

        let mode = 'edit';
        const auth = new AuthService({
            mode: mode,
            isMember: group.isMember(user ? user.id : null),
            isAdmin: group.isAdmin(user ? user.id : null)
        });
        this._auth = auth;

        window.onbeforeunload = function(){
            const isUnsaved = function(model) {
                const state = model.syncState;
                return (
                    state.isSyncing() ||
                    state.isUnsync() ||
                    state.isConflict()
                )
            };
            if(
                ElementRepository.getNodes({
                    context: oldContext
                }).any(isUnsaved) ||
                ElementRepository.getLinks({
                    context: oldContext
                }).any(isUnsaved) ||
                DiagramRepository.getNodeMetas({
                    context: oldContext
                }).any(isUnsaved) ||
                DiagramRepository.getLinkMetas({
                    context: oldContext
                }).any(isUnsaved)
            ) {
                return i18n.t('notify.not-save');
            }
        };

        (new DiagramImportAPI).fetchDiagramWithElements(project, this.model, importRequestID)
            .then(result => {
                // 現状 preview 実行時に Tag が生成されるのでここで読み込むようにする
                TagAction.fetchTags(this.model.getProjectId());

                const dt = null;

                const diagram = DiagramRepository.getDiagrams({
                    context: {
                        projectId: project.id
                    }
                }).get(result.diagram.id);
                // meta 情報を作成
                const nodeMeta = _.map(result.diagram.records, (v, k) => {
                    let j = v;
                    j['id'] = k;
                    j['creating'] = true;
                    return j;
                });
                Dispatcher.dispatch({
                    type: Actions.CREATE_NODE_META,
                    context: oldContext,
                    nodeMeta: nodeMeta
                });
                Dispatcher.dispatch({
                    type: Actions.UPDATE_NODE_META_SYNC_STATE,
                    context: oldContext,
                    state: SyncState.States.unsync,
                    nodeMeta: nodeMeta
                });

                const linkMeta = _.map(result.diagram.relations, (v, k) => {
                    let j = v;
                    j['id'] = k;
                    j['creating'] = true;
                    return j;
                });
                Dispatcher.dispatch({
                    type: Actions.CREATE_LINK_META,
                    context: oldContext,
                    linkMeta: linkMeta
                });
                Dispatcher.dispatch({
                    type: Actions.UPDATE_LINK_META_SYNC_STATE,
                    context: oldContext,
                    state: SyncState.States.unsync,
                    linkMeta: linkMeta
                });

                const nodes = _.map(result.nodes, v => {
                    v['creating'] = true;
                    return v;
                });
                Dispatcher.dispatch({
                    type: Actions.CREATE_NODE,
                    context: oldContext,
                    node: nodes,
                    options: {fetched: true}
                });
                Dispatcher.dispatch({
                    type: Actions.UPDATE_NODE_SYNC_STATE,
                    context: oldContext,
                    state: SyncState.States.unsync,
                    node: nodes
                });
                const links = _.map(result.links, v => {
                    v['creating'] = true;
                    return v;
                });
                Dispatcher.dispatch({
                    type: Actions.CREATE_LINK,
                    context: oldContext,
                    link: links,
                    options: {fetched: true}
                });
                Dispatcher.dispatch({
                    type: Actions.UPDATE_LINK_SYNC_STATE,
                    context: oldContext,
                    state: SyncState.States.unsync,
                    link: links
                });

                this.showChildView('content', new CanvasView({
                    model: diagram,
                    context: context,
                    oldContext: oldContext,
                    channel: channel,
                    auth: auth,
                    user: user,
                    group: group,
                    project: project,
                    appInfo: appInfo
                }));

                const pattern = new RegExp('#/elements/([0-9a-f]+)');
                const id = location.hash && location.hash.match(pattern) &&
                    location.hash.match(pattern)[1];
                let models = [];

                if(id) {
                    models = channel.request('find:elements:idStartsWith', id);
                }

                if(models.length == 1) {
                    models[0].select();
                    channel.request('canvas:zoomTo', models[0], 0);
                } else {
                    channel.request('canvas:showFull', 0);
                }

                // id が str から始まる element のリストを返す
                const getElementsOfIdStartsWith = function(str) {
                    if (str[0] == '#') {
                        str = str.slice(1);
                    }
                    const idStartsWith = function(model) {
                        return model.id.indexOf(str) == 0;
                    };
                    const nodes = ElementRepository.getNodes({
                        context: oldContext
                    }).filter(idStartsWith);
                    const links = ElementRepository.getLinks({
                        context: oldContext
                    }).filter(idStartsWith);

                    return _.flatten([nodes, links]);
                };
                channel.reply('find:elements:idStartsWith', getElementsOfIdStartsWith);

                window.addEventListener('hashchange', () => {
                    const pattern = new RegExp('#/elements/([0-9a-f]+)');
                    const elementID = location.hash && location.hash.match(pattern) && location.hash.match(pattern)[1];
                    if(!elementID) {
                        return;
                    }

                    _.each(getElementsOfIdStartsWith(elementID), e => e.select());
                }, false);

                channel.reply('cmd:save', function(params){
                    const j = {
                        context: oldContext,
                        metas: {nodes: {}, links: {}},
                        models: {nodes: [], links: []}
                    };
                    _.each(params.nodes, function(n) {
                        j.models.nodes.push(n.toJSON());
                    });
                    _.each(params.links, function(l) {
                        j.models.links.push(l.toJSON());
                    });
                    _.each(params.nodeMetas, function(n) {
                        const k = {};
                        k[n.id] = n.toJSON();
                        j.metas.nodes = _.extend(
                            j.metas.nodes, k);
                    });
                    _.each(params.linkMetas, function(n) {
                        const k = {};
                        k[n.id] = n.toJSON();
                        j.metas.links = _.extend(
                            j.metas.links, k);
                    });

                    return ElementAction.saveElements(j);
                });
            });

        this.showChildView('nav', new NavView({
            model: project,
            context: context.getParent(), // ProjectContext
            diagram: this.model
        }));

        this.showChildView('toolbar', new ToolbarView({
            model: this.model,
            context: context,
            oldContext: oldContext,
            channel: channel,
            messengerChannel: this.getOption('messengerChannel'),
            auth: auth,
            user: user,
            group: group,
            project: project
        }));

        this.setModeIndicator();
        this.listenTo(auth, 'change:mode', this.setModeIndicator);

        const navs = new SidebarCollection(
            [
                {
                    name: 'description',
                    icon: 'fa fa-info-circle',
                    label: 'module/word:description',
                    view: new DescriptionView({
                        model: this.model
                    })
                },
                {
                    name: 'members',
                    icon: 'fa fa-user',
                    label: 'module/word:member',
                    view: new OwnerListView({
                        collection: group.getMembers({withSuspended: true}),
                        context: oldContext,
                        channel: channel,
                        diagramContext: oldContext
                    })
                },
                {
                    name: 'tags',
                    icon: 'fa fa-tags',
                    label: 'module/word:tag',
                    view: new TagListView({
                        editable: auth.isEditable(),
                        context: oldContext,
                        channel: channel,
                        diagramContext: oldContext
                    })
                }
            ]
        );

        this.showChildView('sidebar', new SidebarView({
            model: this.model,
            navs: navs,
            horizontalNav: true
        }));
        this.getChildView('toolbar').renderNav(navs);
    },

    setModeIndicator: function() {
        const mode = this._auth.getMode();

        if(mode == 'view') {
            this.showChildView('modeIndicator', new ModeIndicatorView({
                iconClass: 'fa fa-eye',
                title: i18n.t('diagram:editMode.view.name')
            }));

            return;
        }

        if (mode == 'multi' || mode == 'rectSelect') {
            this.showChildView('modeIndicator', new ModeIndicatorView({
                iconClass: 'fa fa-object-group',
                title: i18n.t('diagram:editMode.multi.name')
            }));

            return;
        }

        this.getRegion('modeIndicator').empty();
    },

    onDestroy: function() {
        const channel = this.getOption('channel');

        channel.off('append:comment:records');
        channel.off('append:comment:record');
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/diagram-import/index.js